
import ModelService from "@/service/ModelService"; 

class IndexModel extends ModelService { 
      
    constructor() {
        super();
        this.url = this.versao + '/elastic' ; 
    }
   
    public getAll( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
   

    public createIndex( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + `/Index` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
    
    
    public deleteIndex( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().delete( this.url + `/Index` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }



}
  
export default IndexModel; 